import { useEffect, useState } from 'react';
import { fetchMeterVersions } from '../services/meter.api';

export function deriveStatus(from, to) {
  const now = new Date();
  const fromDt = from ? new Date(from) : null;
  const toDt = to ? new Date(to) : null;
  if (fromDt && fromDt > now) return 'Pending';
  if (!toDt || toDt >= now) return 'Active';
  return 'Historical';
}

export function useMeterVersions(meterNumber) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!meterNumber) return;
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const raw = await fetchMeterVersions(meterNumber);
        const mapped = Array.isArray(raw)
          ? raw.map((r) => ({
              unitStatus: deriveStatus(r.FromDate, r.ToDate),
              EVN: r.EVN ?? null,
              TrainNumber: r.TrainNumber ?? null,
              FromDate: r.FromDate ?? null,
              ToDate: r.ToDate ?? null,
              Comments: typeof r.Comments === 'string' ? r.Comments.trim() : r.Comments,
              Faulty: r.Faulty ?? null,
              AssignmentRecordedOn: r.AssignmentRecordedOn ?? r.CreationDate ?? null,
            }))
          : [];
        if (!alive) return;
        setVersions(mapped);
      } catch (e) {
        console.error('useMeterVersions:', e);
        if (alive) setVersions([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [meterNumber]);

  return { loading, versions };
}
